export default __webpack_public_path__ + "e752ca42d1e4068e088f3efbd7e6050d.svg";